import {
  RegimeEstadual,
  RegimeEstadualValidation,
  RegimeEstadualNoValidation,
} from "./RegimeEstadual";
import {
  RegimeFederal,
  RegimeFederalValidation,
  RegimeFederalNoValidation,
} from "./RegimeFederal";

class Regime {
  constructor() {
    this.federal = new RegimeFederal();
    this.estadual = new RegimeEstadual();
  }
}

const RegimeValidation = {
  federal: RegimeFederalValidation,
  estadual: RegimeEstadualValidation,
};

const RegimeNoValidation = {
  federal: RegimeFederalNoValidation,
  estadual: RegimeEstadualNoValidation,
};

export { Regime, RegimeValidation, RegimeNoValidation };
